<template>
  <div class="logo">
    <img class="logo__img" src="../../assets/img/pond_logo.png" alt="pension on demand">
  </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;

  &__img {
    max-height: 60px;
  }

  &--nav {
    margin: 0 1rem;

    .logo__img {
      max-height: 50px;

      @include breakpoints(small) {
        max-height: 80px;
      }
    }
  }
}
</style>